<div class="card m-0 bg-transparent">
  <div class="card-body">
    <form [formGroup]="datepickerForm">
      <div
        class="mb-3"
        *ngIf="
          button &&
          (button?.button_form === buttonFormTypes.DATEPICKER ||
            button?.button_form === buttonFormTypes.DATERANGEPICKER)
        "
      >
        <label
          for="format"
          class="offcanvas-header-text w-100"
          style="text-align: left"
          >Select Date Format</label
        >
        <select
          id="format"
          class="form-select offcanvas-primary ng-pristine ng-valid ng-touched border-0 shadow-none"
          formControlName="format"
          (change)="onChange()"
        >
          <option value="yyyy-MM-dd">YYYY-MM-DD</option>
          <option value="dd-MM-yyyy">DD-MM-YYYY</option>
          <option value="MM-dd-yyyy">MM-DD-YYYY</option>
          <option value="yyyy/MM/dd">YYYY/MM/DD</option>
          <option value="dd/MM/yyyy">DD/MM/YYYY</option>
          <option value="MM/dd/yyyy">MM/DD/YYYY</option>
        </select>
      </div>
      <div
        class="mb-3"
        *ngIf="button && button?.button_form === buttonFormTypes.TIMEPICKER"
      >
        <label
          for="format"
          class="offcanvas-header-text w-100"
          style="text-align: left"
          >Select Time Format</label
        >
        <select
          id="format"
          class="form-select offcanvas-primary ng-pristine ng-valid ng-touched border-0 shadow-none"
          formControlName="format"
          (change)="onChange()"
        >
          <option value="HH:mm">HH:mm</option>
          <option value="hh:mm a">HH:mm (am/pm)</option>
        </select>
      </div>
      @if(button && (button?.button_form === buttonFormTypes.DATEPICKER ||
      button?.button_form === buttonFormTypes.DATERANGEPICKER)){
      <div class="row">
        <div class="col-6">
          <div class="mb-3">
            <label
              for="format"
              class="offcanvas-header-text w-100"
              style="text-align: left"
              >Minimum Date</label
            >
            <input
              class="form-control input-lg offcanvas-primary border-0"
              placeholder="Enter Date"
              name="dp"
              bsDatepicker
              [bsConfig]="{
                showWeekNumbers: false,
                adaptivePosition: true,
                container: 'body'
              }"
              autocomplete="off"
              formControlName="min_date"
              (bsValueChange)="onChangeDate($event, 'min_date')"
            />
          </div>
        </div>
        <div class="col-6">
          <div class="mb-3">
            <label
              for="format"
              class="offcanvas-header-text w-100"
              style="text-align: left"
              >Maximum Date</label
            >
            <input
              class="form-control input-lg offcanvas-primary border-0"
              placeholder="Enter Date"
              name="dp"
              bsDatepicker
              [bsConfig]="{
                showWeekNumbers: false,
                adaptivePosition: true,
                container: 'body'
              }"
              autocomplete="off"
              formControlName="max_date"
              (bsValueChange)="onChangeDate($event, 'max_date')"
            />
          </div>
        </div>
      </div>
      }
      <div class="mb-3">
        <label
          for="label"
          class="offcanvas-header-text w-100"
          style="text-align: left"
          >Calendar Label</label
        >
        <input
          type="text"
          class="form-control input-lg offcanvas-primary border-0"
          id="label"
          formControlName="label"
          placeholder="Enter label"
          (change)="onChange()"
        />
      </div>
      <div>
        <label
          for="label"
          class="offcanvas-header-text w-100"
          style="text-align: left"
          >Select Calendar Style</label
        >
        <div class="row mt-3 mx-0">
          <div *ngFor="let layout of list" class="col-md-4 col-sm-6 col-6 p-1 m-0">
            <span
              class="text-center mb-2 font-size-12 d-flex flex-column justify-content-center fw-semibold offcanvas-header-text"
            >
              {{ layout.title }}
            </span>
            <div class="mb-2">
              <label class="card-radio-label mb-2">
                <input
                  type="radio"
                  name="currency"
                  [id]="layout.key"
                  class="card-radio-input"
                  (change)="selectLayeout(layout)"
                  [checked]="layout.key === datepickerForm?.get('style').value"
                />

                <div class="card-radio p-0">
                  <div class="d-flex flex-column justify-content-center p-0">
                    <img [src]="layout.image" style="width: 100%;" />
                  </div>
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
